import {JSONMapped, jsonProperty} from "json-mapper-reflect";

import {AvdbEventType} from "./avdb-event-type";
import {AvdbStatusEventMetadata} from "./avdb-status-event-metadata";
import * as JSONMapper from "json-mapper";

export class AvdbStatusEvent extends JSONMapped() {

	@jsonProperty()
	uuid: string;

	@jsonProperty()
	avdbId: number;

	@jsonProperty()
	avdbIssueId: number;

	@jsonProperty()
	fixedDeviceUuid: string;

	@jsonProperty()
	portableDeviceUuid: string;

	@jsonProperty()
	eventDate: string;

	@jsonProperty(JSONMapper.classByMethods(AvdbEventType))
	eventType: AvdbEventType;

	@jsonProperty(JSONMapper.classByMethods(AvdbStatusEventMetadata))
	metadata: AvdbStatusEventMetadata;

	constructor(data?: Partial<AvdbStatusEvent>) {
		super();
		Object.assign(this, data);
	}
}
